
import ParseExpression from './ParseExpression.js'
import ParseSentences from './ParseSentences.js'

function ParseSentenceIf (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.SC = parser.config
    this.hintHelper = parser.hintHelper
}

ParseSentenceIf.prototype = {
    parse () {
        let resultType
        let firstToken
        let branch
        let jumpEndTrue
        let expectedToken
        let autocompleteWithEndIf = false
        let parseExpression = new ParseExpression(this.parser)
        let parseSentences = new ParseSentences(this.parser)

        this.parser.expect(this.SC.K_IF)

        firstToken = this.scanner.next()

        resultType = parseExpression.parse()

        if (!resultType.isBool()) {
            this.parser.error(firstToken, 'Se esperaba una expresión lógica.')
        }

        expectedToken = this.parser.expect(this.SC.K_THEN)
        if (this.hintHelper && expectedToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_THEN])
            this.hintHelper.disable()
        } else if (this.parser.isAutocomplete) {
            if (expectedToken !== false && expectedToken.line === this.parser.autocompleteLine) {
                autocompleteWithEndIf = true
            }
        }

        if (this.parser.compile) {
            branch = this.pcode.branch(0, firstToken)
        }

        parseSentences.parse()

        if (this.hintHelper) {
            this.hintHelper.checkTokensForHints([this.SC.K_ELSE])
        }
        if (this.scanner.nextIs(this.SC.K_ELSE)) {
            if (this.parser.compile) {
                jumpEndTrue = this.pcode.jump(0, this.scanner.next())
            }
            this.parser.expect(this.SC.K_ELSE)
            if (this.parser.compile) {
                branch.op1 = this.pcode.instructionCount() + 1
            }

            parseSentences.parse()

            if (this.hintHelper) {
                this.hintHelper.checkTokensForHints([this.SC.K_END_IF])
            }
            this.parser.expect(this.SC.K_END_IF)

            if (this.parser.compile) {
                jumpEndTrue.op1 = this.pcode.instructionCount() + 1
            }
        } else {
            expectedToken = this.parser.expect(this.SC.K_END_IF)
            if (this.hintHelper && expectedToken === false) {
                this.hintHelper.checkTokensForHints([this.SC.K_END_IF], '\n')
                this.hintHelper.checkTokensForHints([this.SC.K_ELSE])
            } else if (this.parser.isAutocomplete && autocompleteWithEndIf && expectedToken === false) {
                this.parser.callbacks.autocomplete(this.SC.K_END_IF.keywords[0], 1)
                this.parser.isAutocomplete = false
            }
            if (this.parser.compile) {
                branch.op1 = this.pcode.instructionCount() + 1
            }
        }
    }

}

export default ParseSentenceIf



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseSentenceIf.js